import { CategoriesServices } from "../../../../services";
import { Button, Modal } from "semantic-ui-react";
import React from "react";
import "./styles.scss";
import { PromptCard } from "../../../Cells";
import { useSocialCoachSession, validateLong } from "../../../../utils";
import { EditableField } from "../../../Inputs";
import { Category, Prompt } from "../../../../interfaces";

interface OwnProps {
  open: boolean;
  onClose: () => void;
  category?: Category;
  prompts: Prompt[];
  canEdit: boolean;
  onUpdate: (category: Category) => void;
  selectPrompt: (prompt: Prompt) => void;
}

type Props = OwnProps;

export const PromptCategoryModal: React.FC<Props> = ({
  open,
  onClose,
  category,
  prompts,
  canEdit,
  onUpdate,
  selectPrompt,
}) => {
  const { coachId } = useSocialCoachSession();
  const changeCategoryName = (category: Category, newValue: string) => {
    const newCatName = newValue ? newValue.trim() : newValue;
    if (coachId && newValue && validateLong(2, 25, newValue)) {
      CategoriesServices.update(coachId, { ...category, name: newCatName })
        .then(newCategory => {
          onUpdate(newCategory);
        })
        .catch(e => {
          if (e.status === 409) {
            alert("You already have a category named: " + newCatName);
          } else {
            alert(e.message);
          }
        });
    } else {
      alert("Category name should have 2-25 characters.");
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={"promptCategoryModal"}
      size={prompts.length > 15 ? "fullscreen" : "large"}
    >
      {category && (
        <>
          <Modal.Header>
            <EditableField
              headerType={"h3"}
              name={"libraryCategoryId" + category.name}
              currentValue={category.name}
              handleChangeValue={value => changeCategoryName(category, value)}
              disable={!canEdit}
            />
          </Modal.Header>
          <Modal.Content className={"cardGridContent"}>
            <div className={"cardGrid"}>
              {prompts.map(prompt => {
                return (
                  <PromptCard
                    key={`selected-prompt-card-${prompt.promptId}`}
                    prompt={prompt}
                    onClick={() => selectPrompt(prompt)}
                  />
                );
              })}
            </div>
          </Modal.Content>
        </>
      )}
      <Modal.Actions>
        <Button onClick={onClose} className={"rounded"} secondary>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
